import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { setPosition } from "./TooltipOverridePosition";

export default class Tooltip extends Component {
	componentDidMount() {
		window.addEventListener("resize", this.toggleTooltip);
	}
	componentDidUpdate(prevProps) {
		if (this.props.clickable && prevProps.isVisible !== this.props.isVisible) {
			this.toggleTooltip();
		}
	}
	overridePosition = (
		{ left, top },
		currentEvent,
		currentTarget,
		node,
		place,
		desiredPlace,
		effect,
		offset
	) => {
		const { position, tooltipPosition = this.props.position } = this.props;
		return setPosition(
			{ left, top },
			currentEvent,
			currentTarget,
			node,
			place,
			desiredPlace,
			effect,
			offset,
			position,
			tooltipPosition
		);
	};

	toggleTooltip = () => {
		const { isVisible, buttonRef } = this.props;
		if (isVisible) {
			ReactTooltip.show(buttonRef.current);
		} else {
			ReactTooltip.hide(buttonRef.current);
		}
		ReactTooltip.rebuild();
	};
	render() {
		const { id, className = "", position = "bottom" } = this.props;
		return (
			<ReactTooltip
				className={className}
				html={true}
				id={id}
				place={position}
				border={true}
				overridePosition={this.overridePosition}
				scrollHide={true}
				resizeHide={true}
			/>
		);
	}
	static propTypes = {
		id: PropTypes.string.isRequired,
		position: PropTypes.string.isRequired,
		tooltipPosition: PropTypes.string,
		className: PropTypes.string,
		isVisible: PropTypes.bool,
		buttonRef: PropTypes.object
	};
}
